import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import dynamic from 'next/dynamic';
import styles from './gdprMessage.module.scss';

const Gdpr = dynamic(
  () => import('@lionstep/ui-v2').then((module) => module.Gdpr),
  {
    ssr: false,
  },
);

const GdprMessage = (props) => {
  const { t } = useTranslation('common');

  return (
    <Gdpr
      acceptText={t('gdpr.accept')}
      termsText={t('gdpr.terms_and_conditions')}
      acknowledgeText={t('gdpr.acknowledge')}
      policyText={t('gdpr.privacy_policy')}
      fromText={t('gdpr.from')}
      linkClassName={styles.link}
      {...props}
    />
  );
};

export default GdprMessage;
